/*
 * @Description: 文件上传配置
 * @version: 1.0.0
 * @Author: Monkey
 * @Date: 2025-03-05 14:57:02
 * @LastEditors: Monkey
 * @LastEditTime: 2025-05-11 15:06:36
 */
import API from "@/api";

//上传配置

const baseUrl = process.env.VUE_APP_IMG_BASEURL
export default {
  apiObj: API.common.upload,			//上传请求API对象
  filename: "file",					//form请求时文件的key
  successCode: 0,					//请求完成代码
  maxSize: 10,						//最大文件大小 默认10MB
  parseData: function (res) {
    const item = res.data[0];
    return {
      ...item,
      code: res.code,
      fileThumPath: baseUrl + item.fileThumPath,
      filePath: baseUrl + item.filePath,
      fileId: item.fileId || item.id, // 确保返回fileId字段
      msg: res.message
    }
  },
  apiObjFile: API.common.upload,	//附件上传请求API对象
  maxSizeFile: 10						//最大文件大小 默认10MB
}
